export default function toDecimalPlaces(numberToFormat, decimalPlaces = 1) {
  const formatter = Math.pow(10, decimalPlaces);
  return numberToFormat && parseInt(numberToFormat * formatter) / formatter;
}
